const locale = {
  placeholder: '請選擇時間',
};

export default locale;



// WEBPACK FOOTER //
// ./components/time-picker/locale/zh_TW.tsx